<div class="layout-topbar">
  <div class="topbar-left">
    <button
      aria-label="Menu"
      data-testid="menu-button"
      type="button"
      class="menu-button"
      [ngClass]="{ hidden: isReveal() }"
      (click)="onMenuButtonClick()"
      (keyup.enter)="onMenuButtonClick()">
      <i
        class="pi max-lg:hidden"
        [ngClass]="{ 'pi-chevron-right': isInactive(), 'pi-chevron-left': !isInactive(), 'pi-bars': isOverlay() }"></i>
      <i class="pi pi-bars lg:hidden"></i>
    </button>
    <span class="topbar-separator" [ngClass]="{ '!hidden': isReveal() }"></span>
    <a class="lg:hidden mr-4" href="/">
      <app-convivia-logo size="2.1875rem"></app-convivia-logo>
    </a>
    <app-breadcrumb></app-breadcrumb>
  </div>
  <div class="topbar-right">
    <app-tenant-switcher />
    <ul class="topbar-menu">
      <li class="static sm:relative">
        <app-notification-inbox></app-notification-inbox>
      </li>
      <li class="profile-item static sm:relative">
        <a
          class="right-sidebar-button"
          pStyleClass="@next"
          enterFromClass="hidden"
          enterActiveClass="animate-scalein"
          leaveActiveClass="animate-fadeout"
          leaveToClass="hidden"
          [hideOnOutsideClick]="true">
          <p-avatar icon="pi pi-user" size="normal" />
        </a>
        <div class="user-menu hidden" role="menu">
          <ng-container *ngTemplateOutlet="menu"></ng-container>
        </div>
      </li>
    </ul>
  </div>
</div>

<ng-template #menu>
  <ul>
    @if (getCurrentUser()) {
      <li>
        <p class="hover:!bg-transparent font-bold hover:!cursor-default">{{ getCurrentUser() | titlecase }}</p>
      </li>
    }
    <li>
      <button (keyup.enter)="onConfigButtonClick()" (click)="onConfigButtonClick()">
        <i class="pi pi-cog"></i>
        <span>Configuraciones</span>
      </button>
    </li>
    <li>
      <button (click)="logout()" (keyup.enter)="logout()">
        <i class="pi pi-power-off"></i>
        <span>Cerrar sesión</span>
      </button>
    </li>
  </ul>
</ng-template>
